module.exports = __webpack_public_path__ + "img/xinsui.29a42d06.png";